// extracted by mini-css-extract-plugin
export default {"header":"Layout_header__05R8D","header-dark":"Layout_header-dark__fozAX","container":"Layout_container__3lZO0"};